<template>
    <div class="page-overview-header">
        <b-media
            class="magazine-tip-of-the-day"
            v-if="getRandomTip() && !tipDisabled">
            <b-button
                class="btn-times btn-dismiss-tip remove-icon-margin"
                variant="primary-icon-only"
                @click="disableTip">
            </b-button>
            <template #aside>
                <b-img src="/images/ellen.png"></b-img>
                <div class="name">Ellen's tip:</div>
            </template>
            <h5 class="tip-of-the-day-title">{{ title }}</h5>
            <p class="tip-of-the-day-body">{{ value }}</p>
        </b-media>

        <div class="magazine-tools">
            <a
                class="btn btn-primary-icon-only btn-edit"
                v-b-tooltip.hover.center
                v-if="$authUser.isAdmin()"
                :href="routes.magazineSettings(magazineId)"
                :title="$t('magazine.settings')"></a>

            <design-2021-magazine-approve-all-pages-component
                v-if="ischiefeditor"
                :magazine-in="magazineIn"
                :yearbook-settings-in="yearbookSettingsIn"
                :current-season="currentSeason">
            </design-2021-magazine-approve-all-pages-component>

            <a
                class="btn btn-primary-icon-only btn-sorting"
                v-b-tooltip.hover
                v-if="ischiefeditor"
                :href="routes.magazineOrder(magazineId)"
                :title="$t('magazine.page_order')"></a>

            <a
                class="btn btn-primary-icon-only btn-lock"
                v-b-tooltip.hover
                v-if="ischiefeditor"
                :href="routes.magazineRights(magazineId)"
                :title="$t('magazine.page_rights')"></a>

            <a
                class="btn btn-primary-icon-only btn-users btn-editors-settings"
                v-b-tooltip.hover
                :href="routes.magazineEditors(magazineId)"
                :title="$t('magazine.redaction')"></a>

            <a
                class="btn btn-primary-icon-only btn-duplicate btn-copy-magazine"
                v-b-tooltip.hover
                v-if="ischiefeditor"
                :href="routes.magazineTemplateArchive(magazineId)"
                :title="$t('magazine.templates')"></a>

            <a
                class="btn btn-primary-icon-only btn-download"
                v-b-tooltip.hover
                v-if="ischiefeditor"
                :href="routes.magazineLowresPdf(magazineId)"
                title="Download Pdf"></a>

            <b-dropdown
                class="dropdown-page-settings ellipsis-nav"
                id="magazine-dropdown"
                v-if="$authUser.isAdmin()"
                v-b-tooltip.hover
                text=""
                variant="primary"
                :title="$t('magazine.other')">
                <b-dropdown-item
                    class="remove-magazine-page"
                    :href="routes.magazineDeleteMultiplePages(magazineId)">
                    <i class="btn-remove"></i>{{ $t('magazine.delete_pages') }}
                </b-dropdown-item>
                <b-dropdown-item class="add-magazine-page">
                    <design-2021-magazine-add-pages-component
                        :magazine-id="magazineId"></design-2021-magazine-add-pages-component>
                </b-dropdown-item>
                <b-dropdown-item class="release-all-pages">
                    <design-2021-magazine-release-all-pages-component
                        :magazine-id="magazineId"></design-2021-magazine-release-all-pages-component>
                </b-dropdown-item>
                <b-dropdown-item
                    class="remove-magazine-pdf-inner"
                    v-if="pdfInner !== null"
                    target="_blank"
                    :href="pdfInner">
                    <i class="btn-remove"></i>Highres pdf
                </b-dropdown-item>
                <b-dropdown-item
                    class="remove-magazine-pdf-cover"
                    v-if="pdfCover"
                    target="_blank"
                    :href="pdfCover">
                    <i class="btn-remove"></i>Highres cover pdf
                </b-dropdown-item>
            </b-dropdown>

            <b-button
                class="btn-lightbulb-on btn-show-magazine-tips"
                v-b-tooltip:hover
                v-b-modal="'tips-overview-modal'"
                v-if="tips.length >= 1"
                variant="primary-icon-only"
                :title="$t('magazine.tips_overview')">
            </b-button>
            <design-2021-magazine-pageoverview-tips-overview-modal-component :tips-in="tips">
            </design-2021-magazine-pageoverview-tips-overview-modal-component>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'design-2021-magazine-pageoverview-options-component',
    props: [
        'magazineId',
        'ischiefeditor',
        'pdfInner',
        'pdfCover',
        'tipsIn',
        'magazineIn',
        'yearbookSettingsIn',
        'currentSeason',
    ],
    data() {
        return {
            tips:
                this.ischiefeditor === 1
                    ? this.tipsIn.filter((tip) => tip.magazine_user_role_id === 1)
                    : this.tipsIn.filter((tip) => tip.magazine_user_role_id === 2),
            title: '',
            value: '',
            tipDisabled: false,
        };
    },

    mounted() {
        const now = moment();
        const timeElapsed = '259200000'; //equivalent to 3 days
        this.tipDisabled = false;

        if (localStorage.getItem(`disabledTip-${this.$authUser.id}`)) {
            const localDate = localStorage.getItem(`disabledTip-${this.$authUser.id}`);
            this.tipDisabled = now.diff(localDate) > timeElapsed ? false : true;
        }
    },

    methods: {
        getRandomTip() {
            if (this.tips.length >= 1) {
                const index = Math.floor(Math.random() * this.tips.length);
                this.title = this.tips[index].title;
                this.value = this.tips[index].value;
                return true;
            }

            return false;
        },

        disableTip() {
            localStorage.setItem(`disabledTip-${this.$authUser.id}`, moment());
            this.tipDisabled = true;
        },
    },
};
</script>

<style scoped lang="scss">
@keyframes slide-in {
    0% {
        left: calc(-50% - 15px);
    }
    100% {
        left: 0;
    }
}

.page-overview-header {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-start;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .magazine-tip-of-the-day {
        position: relative;
        padding: map-get($grid-gutter-spacing, 'ten');
        background-color: $white;
        border-radius: $border-radius-content;
        box-shadow: 3px 4px 15px 0 #cccece38;
        animation: slide-in steps(30) 0.8s 1;
        margin-top: map-get($grid-gutter-spacing, 'ten');

        .btn-dismiss-tip {
            position: absolute;
            right: 8px;
            top: 8px;
        }

        .media-aside {
            flex-direction: column;
            justify-content: center !important;

            img {
                width: 40px;
                height: 40px;
                align-self: center;
            }

            .name {
                color: $primary;
                font-weight: $font-weight-medium;
            }
        }

        .tip-of-the-day-title {
            font-weight: $font-weight-medium;
            margin-bottom: 0;
        }

        .tip-of-the-day-body {
            color: $text-muted-color;
        }
    }

    .magazine-tools {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 10px;
        margin-left: auto;

        > a,
        button {
            font-size: 1.4em;
        }

        .btn {
            &:before {
                margin-right: 0;
            }
        }

        .btn-show-magazine-tips {
            font-size: 1.5625rem;
        }
    }

    .dropdown-page-settings {
        ::v-deep .dropdown-toggle {
            font-size: 1.5625rem;
            align-self: center;
            padding: 0;
            line-height: 1;
        }

        .dropdown-menu {
            border: 1px solid $border-color;
        }

        .remove-magazine-page ::v-deep,
        .remove-magazine-pdf-inner ::v-deep,
        .remove-magazine-pdf-cover ::v-deep {
            .dropdown-item {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                i {
                    width: 20px;
                    color: $danger;
                    margin-right: map-get($grid-gutter-spacing, 'eight');
                }
            }
        }

        .add-magazine-page,
        .release-all-pages {
            i {
                color: $primary;
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }
        }
    }

    .btn-editors-settings,
    .btn-copy-magazine {
        &:before,
        &:after {
            align-self: center;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .page-overview-header {
        flex-direction: row;

        .magazine-tip-of-the-day {
            width: calc(50% - 15px);
            margin-top: 0;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .page-overview-header {
        flex-direction: row;

        .magazine-tools {
            justify-content: flex-end;
            gap: 21px;
        }
    }
}
</style>
